import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import routes from '../../../../../Routes/routes';
import { getUrlParameters } from "../../External/Model/Model";
import { REQUEST_ACCESS_TYPE } from "../Model/Model";

/**
 * QrRequestAccessMainApp
 *
 * Hook to manage the main QR Request Access page.
 * Handles the selection of the request type (Find Existing Profile or I Am New Here)
 * and navigation to the corresponding flow.
 *
 * @author Karen Yunuen
 * @jobTitle Full Stack Developer - IBL
 * @email kpozos@ibl.mx
 **/
const QrRequestAccessMainApp = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [selectionType, setSelectionType] = useState(null);

    /**
     * Navigate to the selected request access flow.
     * Shows a warning toast if no option is selected.
     */
    const getUrl = () => {
        if (selectionType == null) {
            toast.warn(t("you_must_select_an_option"));
            return null;
        }

        if (parseInt(selectionType) === REQUEST_ACCESS_TYPE.FIND_EXISTING_PROFILE.INDEX) {
            navigate(getUrlParameters({ url: routes.qrRequestAccess.findMySelf }));
        } else if (parseInt(selectionType) === REQUEST_ACCESS_TYPE.I_AM_NEW_HERE.INDEX) {
            navigate(getUrlParameters({ url: routes.qrRequestAccess.iAmNewHere }));
        } else {
            navigate(routes.forbidden);
        }
    };

    return {
        t,
        selectionType,
        setSelectionType,
        getUrl
    };
};

export default QrRequestAccessMainApp;
